import { useConfigurationContext } from "../../root/ConfigurationContext";
import type { Sender } from "./outlook";

/** The default sender from Settings (Lead agent, Outlook): the sales address unless set to the user personally */
export const useDefaultSender = (): Sender =>
  useConfigurationContext().outlook_default_from === "personal"
    ? "personal"
    : "sales";
